import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import z from 'zod'

const schema = z.object({
  historyPage: z.number().int().positive().optional(),
  historySize: z.number().int().positive().optional()
})

export const BsaBatchDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `batch-details/$id`,
    validateSearch: (search) => schema.parse(search),
    component: lazyRouteComponent(() => import('./BsaBatchDetails'))
  })
